import React from 'react';
import ContentLoader from 'react-content-loader';
import useMatchMedia from 'hooks/useMatchMedia';
import { SIZE, Size } from 'models/Size';
import { PORTFOLIO_CARDS_SIZE } from './data';

type PortfolioPlaceholderCardProps = {
  numberOfCards: number;
  size?: Size;
};

const PortfolioPlaceholderCards: React.FC<PortfolioPlaceholderCardProps> = (
  props,
) => {
  const { numberOfCards, size = SIZE.BIG } = props;

  const isPhablet = useMatchMedia('isPhablet');

  const height = PORTFOLIO_CARDS_SIZE[size][isPhablet ? 'mobile' : 'desktop'];

  return (
    <>
      {Array(numberOfCards)
        .fill(0)
        .map((_, i) => (
          <ContentLoader
            key={i}
            viewBox={`0 0 1360 ${height}`}
            backgroundColor="#e7f1fc"
            foregroundColor="#ffffff"
          >
            <rect x="0" y="0" rx="16" ry="16" width="100%" height="100%" />
          </ContentLoader>
        ))}
    </>
  );
};

export default PortfolioPlaceholderCards;
